import { Link } from "react-router-dom";
import { productConfig } from "../config/product";

type BrandMarkProps = {
  /** When true, wraps the wordmark in a home link. */
  linkToHome?: boolean;
  className?: string;
};

/**
 * Text wordmark for now. Structure allows a future local SVG under
 * /assets/brand/ without restructuring pages. Driven by productConfig.
 * Do not use external image hosts.
 */
export function BrandMark({
  linkToHome = true,
  className = "brand-mark",
}: BrandMarkProps) {
  const wordmark = (
    <span className="brand-mark__wordmark">{productConfig.displayName}</span>
  );

  return (
    <span className={className}>
      {/* Future approved mark: local SVG in public/assets/brand/ */}
      {linkToHome ? (
        <Link to="/" className="brand-mark__link">
          {wordmark}
        </Link>
      ) : (
        wordmark
      )}
    </span>
  );
}
